import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT } from '../utilities/FetchHelper';

class AgeTiersService {

    getSrpInventory(data) {
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_SRP_INVENTORY
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }

    return fetchJSON(url, secureGET()).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }

    putSrpInventory(data) {
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_SRP_INVENTORY
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }

    return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }
}

export default new AgeTiersService();